// 用法參考
//
// methods: {
// ...mapActions('confirm', ['confirmModalOpen']),
//   exampleMethod() {
//     try {
//       await this.confirmModalOpen({
//         title: "確認執行",
//         message: "確定要執行嗎？"
//       })
//     } catch (e) {
//       return
//     }
//     do something...
//   }
// }
//
// 新用法@2026.06.29
//
// methods: {
// ...mapActions('confirm', ['confirmModalOpen']),
//     exampleMethod() {
//     try {
//       const result = await this.confirmModalOpen({
//         title: "確認執行",
//         message: "確定要執行嗎？",
//         extraState: {
//           checked: false
//         }
//       })
//
//       if (result.confirmed) {
//         do something...
//       }
//
//       if (result.extra.checked) {
//         do something...
//       }
//     } catch (result) {
//       return
//     }
//     do something...
//   }
// }

export default {
  namespaced: true,

  state: {
    show: false,
    title: "",
    message: "",
    messageClass: [],
    confirmText: "確認",
    cancelText: "取消",
    resolve: null,
    reject: null,
    extraComponent: null, // 使用哪個附加模組 ex: checkbox
    extraState: null,     // 附加模組狀態
  },

  mutations: {
    OPEN(state, payload) {
      state.show = true
      state.title = payload.title
      state.message = payload.message
      state.messageClass = payload.messageClass || []
      state.confirmText = payload.confirmText || "確認"
      state.cancelText = payload.cancelText || "取消"
      state.resolve = payload.resolve
      state.reject = payload.reject
      state.extraComponent = payload.extraComponent || null
      state.extraState = payload.extraState || null
    },

    CLOSE(state) {
      state.show = false
      state.title = ""
      state.message = ""
      state.messageClass = []
      state.confirmText = "確認"
      state.cancelText = "取消"
      state.resolve = null
      state.reject = null
      state.extraComponent = null
      state.extraState = null
    },

    UPDATE_EXTRA_STATE(state, payload) {
      // 這裡我們直接合併新舊狀態，確保物件屬性不會遺失
      state.extraState = { ...state.extraState, ...payload }
    }
  },

  actions: {
    confirmModalOpen({ commit }, { title, message, messageClass = [], confirmText = "確認", cancelText = "取消", extraComponent, extraState }) {
      return new Promise((resolve, reject) => {
        commit("OPEN", { title, message, messageClass, confirmText, cancelText, resolve, reject, extraComponent, extraState })
      })
    },

    confirmModalConfirm({ state, commit }) {
      // if (state.resolve) state.resolve(true)
      if (state.resolve) {
        state.resolve({
          confirmed: true,
          extra: state.extraState
        })
      }
      commit("CLOSE")
    },

    confirmModalCancel({ state, commit }) {
      // if (state.reject) state.reject(false)
      if(state.reject) {
        state.reject({
          confirmed: false,
          extra: state.extraState
        })
      }
      commit("CLOSE")
    },

    updateExtraState({ commit }, payload) {
      commit("UPDATE_EXTRA_STATE", payload)
    },
  }
}
